/* eslint-disable no-unreachable -- TODO: remove this when we have a solution for the marker with label */
import React, { useContext, useCallback, useState } from 'react';
import { withTheme } from 'styled-components';
import { Marker, InfoWindow } from 'react-google-maps';

import AssignmentMapContext from 'modules/assignment-map/map/context';

const DriverMarker = ({ position, selected, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { driver_id, vehicle_id, vehicle_ids, timestamp } = position;

  const handleMarkerClick = useCallback(() => {
    if (!onClick) {
      return;
    }
    onClick({ driverId: driver_id, vehicleId: vehicle_id, vehicleIds: vehicle_ids, timestamp });
  }, [driver_id, vehicle_id, vehicle_ids, onClick, timestamp]);

  // Create custom icon for the driver marker
  const createCustomIcon = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const size = 32;
    canvas.width = size;
    canvas.height = size;

    // Determine background color based on status
    let bgColor = '#4a5568'; // default grey
    if (selected) {
      bgColor = '#3182ce'; // blue for selected
    } else if (position.available) {
      bgColor = '#38a169'; // green for available
    }

    // Draw the marker background
    ctx.fillStyle = bgColor;
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2 - 1, 0, 2 * Math.PI);
    ctx.fill();

    // Add shadow effect
    ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
    ctx.shadowBlur = 2;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 1;

    // Draw journey number if available
    if (position.number_of_journeys > 0) {
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 12px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(position.number_of_journeys.toString(), size / 2, size / 2);
    }

    return {
      url: canvas.toDataURL(),
      scaledSize: new window.google.maps.Size(size, size),
      anchor: new window.google.maps.Point(size / 2, size),
    };
  };

  return (
    <Marker
      key={`${position.latitude}${position.longitude}`}
      position={{
        lat: position.latitude,
        lng: position.longitude,
      }}
      icon={createCustomIcon()}
      zIndex={selected ? 3 : 2}
      onClick={() => {
        handleMarkerClick();
        setIsOpen(!isOpen);
      }}
    >
      {isOpen && (
        <InfoWindow
          onCloseClick={() => setIsOpen(false)}
          options={{
            pixelOffset: new window.google.maps.Size(0, -30),
          }}
        >
          <div style={{ padding: '8px', minWidth: '150px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Driver #{driver_id}</div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
              Vehicle: {vehicle_id}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              Status: {position.available ? 'Available' : 'Unavailable'}
            </div>
            {position.number_of_journeys > 0 && (
              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                Journeys: {position.number_of_journeys}
              </div>
            )}
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

const DriversPositionsDrawer = withTheme(() => {
  const { driverPositions, onDriverMarkerClick, driverSelected } = useContext(AssignmentMapContext);

  const handleClick = useCallback(
    (data) => {
      onDriverMarkerClick(data);
    },
    [onDriverMarkerClick]
  );

  return (
    <>
      {driverPositions.map((position) => (
        <DriverMarker
          position={position}
          onClick={handleClick}
          selected={driverSelected === position.driver_id}
        />
      ))}
    </>
  );
});

export default DriversPositionsDrawer;
